import DelBox from '../comps/DelBox';
import AddDepart from '../models/AddDepart';
import { useEffect, useState, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import AddBed from '../models/AddBed';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';

const Beds = () => {
  const [formData, setFormData] = useState({
    l1: [],
    wards: [],
    bed_ward: '',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata"));
    const roleId = userData?.role_id;
    
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    
    if (storedData) {
      const parsed = JSON.parse(storedData);
      var fd = new FormData();
      fd.append('bed_ward', formData.bed_ward + "");
      fd.append('page_no', formData.page_no + "");
      fd.append('search_key', formData.search_key + "");
      fd.append('bed_user', 1 + "");
      
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({
              ...prev,
              l1: records
            }));
          }
        }
      } catch (error) {
        console.error(error);
      }
      
      fd = new FormData();
      fd.append('cat_type', "ward");
      fd.append('page_no', "none");
      fd.append('search_key', "");
      fd.append('par_by', 1 + "");
      
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({
              ...prev,
              wards: records
            }));
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      page_no: 0
    }));
  };

  const delItem = async (item) => {
    if (!item || !item.bed_id) {
      toast.error("Invalid bed selected");
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Delete bed "${item.bed_name}" permanently?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const fd = new FormData();
      fd.append('bed_id', item.bed_id + "");

      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.delBedUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status) {
          await initData();
          Swal.fire({
            title: 'Deleted!',
            text: 'Bed deleted successfully.',
            icon: 'success',
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            title: 'Failed!',
            text: response.data.message || response.data.success || 'Could not delete bed.',
            icon: 'error',
          });
        }
      } catch (error) {
        console.error('delete bed error:', error);
        Swal.fire({
          title: 'Error!',
          text: 'Server error while deleting bed.',
          icon: 'error',
        });
      }
    });
  };

  const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };

  useEffect(() => {
    console.log('Component mounted');
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
    }

    return () => {
      console.log('Component unmounted');
    };
  }, []);

  // Filter data based on search and ward
  const filteredData = useMemo(() => {
    let data = formData.l1;

    // Search filter
    if (formData.search_key.trim() !== "") {
      data = data.filter(item =>
        (`${item.cat_name}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
         `${item.bed_name}`.toLowerCase().includes(formData.search_key.toLowerCase()))
      );
    }

    // Ward filter
    if (formData.bed_ward !== "") {
      data = data.filter(item => String(item.cat_id) === String(formData.bed_ward));
    }

    return data;
  }, [formData.l1, formData.search_key, formData.bed_ward]);

  // DataTable columns
  const columns = [
    {
      name: 'SN',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '70px',
    },
    {
      name: 'Ward Name',
      selector: row => row.cat_name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Bed Name',
      selector: row => row.bed_name,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Bed Price',
      selector: row => row.bed_price,
      sortable: true,
      right: true,
    },
    {
      name: 'Description',
      selector: row => row.bed_desc,
      sortable: false,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Status',
      cell: row => (
        row?.status === "0" ? (
          <button className="btn btn-sm btn-success">Available</button>
        ) : (
          <button className="btn btn-sm btn-danger">Allocated</button>
        )
      ),
      sortable: true,
      center: true,
    },
    {
      name: 'Action',
      cell: row => (
        row?.status === "0" ? (
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
              onClick={() => { 
                setEditItem(row); 
                document.getElementById("addbt453").click(); 
              }}
            >
              Edit
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
              onClick={() => delItem(row)}
            >
              Delete
            </button>
          </div>
        ) : null
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '200px',
    },
  ];

  // Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        borderBottom: '2px solid #dee2e6',
        fontSize: '13px',
        fontWeight: '600',
        textTransform: 'uppercase',
      },
    },
    headCells: {
      style: {
        paddingLeft: '16px',
        paddingRight: '16px',
      },
    },
    cells: {
      style: {
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Beds</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button 
                        id="addbt453" 
                        style={{ display: "none" }} 
                        type="button" 
                        className="btn btn-success add-btn" 
                        data-bs-toggle="modal" 
                        data-bs-target="#showModal"
                      />
                      <button 
                        type="button" 
                        className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          document.getElementById("addbt453").click();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Bed
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-xxl-5 col-sm-6">
                      <div className="search-box">
                        <input 
                          className="form-control search" 
                          name="search_key" 
                          onChange={handleChange} 
                          value={formData.search_key} 
                          placeholder="Search by ward or bed name..." 
                          type="text" 
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                    <div className="col-xxl-5 col-sm-6">
                      <select 
                        name="bed_ward" 
                        onChange={handleChange} 
                        value={formData.bed_ward} 
                        className="form-control"
                      >
                        <option value="">All Wards</option>
                        {formData.wards.map((item) => (
                          <option key={item.cat_id} value={item.cat_id}>
                            {item.cat_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </form>
              </div>

              <div className="card-body pt-0">
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <h5 className="mt-2">No beds found</h5>
                      <p className="text-muted">Try adjusting your search or filter criteria</p>
                    </div>
                  }
                />
                
                <AddBed item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Beds;